export enum SupportChannel {
  EMAIL = 'Email',
  CHAT = 'Chat',
  PHONE = 'Phone',
  SERVICE_NOW = 'ServiceNow (SNOW)',
  OTHER = 'Other',
}
